import React, { ChangeEvent, useState } from 'react';
import { useController } from 'react-hook-form';

import styles from './FormInput.module.scss';
import { TooltipObject } from '../../models/formModel';
import Popup from '../popup/popup';

interface FormInputProps {
  id: string;
  placeholder?: string;
  label?: string;
  required?: boolean;
  type?: 'text' | 'file' | 'number';
  tooltip?: TooltipObject;
  isDisabled?: boolean;
}

const FormInput: React.FC<FormInputProps> = ({
  id,
  placeholder = 'Placeholder',
  label = '',
  required = false,
  type = 'text',
  tooltip,
  isDisabled = false,
}) => {
  const {
    field: { onChange: inputChanged, value },
  } = useController({
    name: id,
    rules: {
      required: required,
    },
  });

  const [showPopup, setShowPopup] = useState<boolean>(false);

  return (
    <>
      <div className={styles.formInputContainer}>
        <div className={'labelContainer'}>
          <div className={required ? 'requiredLabel' : ''}>{label}</div>
          {tooltip && (
            <img
              className={'tooltipIcon'}
              src="/images/info.png"
              alt=""
              onClick={() => setShowPopup(true)}
            />
          )}
        </div>
        {['text', 'number'].includes(type) ? (
          <input
            id={id}
            value={value}
            type={type}
            placeholder={placeholder}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              inputChanged(e.target.value);
            }}
            disabled={isDisabled}
          />
        ) : (
          <input
            id={id}
            type={type}
            placeholder={placeholder}
            accept="image/*"
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              if (e.target.files) {
                inputChanged(e.target.files[0]);
              } else {
                inputChanged('');
              }
            }}
            disabled={isDisabled}
          />
        )}
      </div>

      <Popup
        show={showPopup}
        title={tooltip?.title}
        onButtonClicked={() => setShowPopup(false)}
      >
        {tooltip?.content}
      </Popup>
    </>
  );
};

export default FormInput;
